export default __webpack_public_path__ + "static/media/certificate6.c6990ad2.svg";